// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sponsor-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap; /* Disable wrapping */
    padding: 20px;
    overflow-x: auto; /* Horizontal scroll */
    scroll-behavior: smooth;
    white-space: nowrap; /* Ensure items stay in a single line */
}

.sponsor-item {
    display: inline-flex; /* Make items inline for horizontal scrolling */
    flex-direction: column;
    align-items: center;
    margin: 10px;
    white-space: normal; /* Allow text wrapping inside item */
}

.sponsor-name {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
}

.sponsor-image {
    width: 150px;
    height: auto;
    object-fit: contain;
}

@media (max-width: 768px) {
    .sponsor-container {
        justify-content: flex-start; /* Align items to the start for scrolling */
        overflow-x: auto; /* Enable horizontal scrolling */
        flex-wrap: nowrap;
    }

    .sponsor-container::-webkit-scrollbar {
        display: none; /* Hide scrollbar on mobile */
    }
}

@keyframes scroll {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-100%);
    }
}

.sponsor-container.auto-scroll {
    display: flex;
    animation: scroll 20s linear infinite; /* Auto-scroll effect */
}
`, "",{"version":3,"sources":["webpack://./src/components/homepage/sponsor/sponsor.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB,EAAE,qBAAqB;IACxC,aAAa;IACb,gBAAgB,EAAE,sBAAsB;IACxC,uBAAuB;IACvB,mBAAmB,EAAE,uCAAuC;AAChE;;AAEA;IACI,oBAAoB,EAAE,+CAA+C;IACrE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB,EAAE,oCAAoC;AAC7D;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,2BAA2B,EAAE,2CAA2C;QACxE,gBAAgB,EAAE,gCAAgC;QAClD,iBAAiB;IACrB;;IAEA;QACI,aAAa,EAAE,6BAA6B;IAChD;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,aAAa;IACb,qCAAqC,EAAE,uBAAuB;AAClE","sourcesContent":[".sponsor-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: nowrap; /* Disable wrapping */\n    padding: 20px;\n    overflow-x: auto; /* Horizontal scroll */\n    scroll-behavior: smooth;\n    white-space: nowrap; /* Ensure items stay in a single line */\n}\n\n.sponsor-item {\n    display: inline-flex; /* Make items inline for horizontal scrolling */\n    flex-direction: column;\n    align-items: center;\n    margin: 10px;\n    white-space: normal; /* Allow text wrapping inside item */\n}\n\n.sponsor-name {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\n.sponsor-image {\n    width: 150px;\n    height: auto;\n    object-fit: contain;\n}\n\n@media (max-width: 768px) {\n    .sponsor-container {\n        justify-content: flex-start; /* Align items to the start for scrolling */\n        overflow-x: auto; /* Enable horizontal scrolling */\n        flex-wrap: nowrap;\n    }\n\n    .sponsor-container::-webkit-scrollbar {\n        display: none; /* Hide scrollbar on mobile */\n    }\n}\n\n@keyframes scroll {\n    0% {\n        transform: translateX(0);\n    }\n    100% {\n        transform: translateX(-100%);\n    }\n}\n\n.sponsor-container.auto-scroll {\n    display: flex;\n    animation: scroll 20s linear infinite; /* Auto-scroll effect */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
